import baseApi from './base.api';
import { useAuthStore } from '@/stores';
export const assasService = {
    ...baseApi,
    resource: 'assinaturaAsaas',
    info(userId) {
        let uId = userId;
        if (!uId) {
            uId = useAuthStore().persistentInfo?.id;
            if (!uId) {
                throw new Error('Usuário não autenticado');
            }
        }
        return baseApi.get(`${this.resource}/subscription/${uId}`)
            .then(({ data: dt }) => {
            return {
                subscriptionId: dt?.id || '',
                name: dt?.nomePlanoAssinatura || '',
                value: dt?.valor,
                status: dt?.status || '',
                createdAt: dt?.dataCriacao || '',
                expiresAt: dt?.dataExpiracao || '',
                canceledAt: dt?.dataCancelamento || '',
                paymentAt: dt?.dataPagamento || '',
                billingDate: dt?.dataProximaCobranca || '',
                renewalDate: dt?.dataRenovacao || '',
                evaluation: dt?.periodoAvaliacaoUtilizado || false,
                receipt: dt?.historicoFaturas || '',
                creditCard: dt?.ultimos4DigitosCartao || '',
                trialExpiresAt: dt?.dataExpiracaoTeste || '',
            };
        });
    },
    unsubscribe(subscriptionId, reason) {
        return baseApi.post(`${this.resource}/subscription/${subscriptionId}/cancel`, {
            motivo: reason
        });
    }
};
